import React, { createContext, useContext, useEffect, useState } from "react";
import api from "../services/api";
import { useAuth } from "./AuthContext";

const UserBaseContext = createContext();

export const UserBaseProvider = ({ children }) => {
  const [userBases, setUserBases] = useState([]);
  const { isAuthenticated, authVersion } = useAuth();

  // Fetch UserBase Options
  const fetchUserBases = async () => {
    try {
      const response = await api.get("/UserBase");
      setUserBases(response.data || []);
    } catch (error) {}
  };

  // Fetch when user is authenticated (and re-fetch after login)
  useEffect(() => {
    if (isAuthenticated) {
      fetchUserBases();
    }
  }, [isAuthenticated, authVersion]);

  return (
    <UserBaseContext.Provider value={{ userBases }}>
      {children}
    </UserBaseContext.Provider>
  );
};

// ✅ Custom Hook to use data
export const useUserBases = () => {
  const { userBases } = useContext(UserBaseContext);
  return userBases;
};
